var React = require('react');

function IcPlayArrow24px (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 5v14l11-7z"}));
}

IcPlayArrow24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcPlayArrow24px;

IcPlayArrow24px.default = IcPlayArrow24px;
